import React from "react"
import ReactNative from "react-native"
import RomanNumerals from "roman-numerals"
import { playSound } from "app/lib/audio"

import Switch from "app/components/Switch"
import { formatTime } from "app/lib/utils/time"
import { connect } from "react-redux"
import Device from "app/lib/Device"
import dataStore from "app/data/dataStore"
import FS from "app/components/FS"
import ValueEditor from "app/components/ValueEditor"
import LoadingOverlay from "app/components/LoadingOverlay"
import ChallengeIcon from "app/components/ChallengeIcon"
import PostType from "app/models/PostType"

import * as Animatable from "react-native-animatable"

import ChallengeLevelSelector from "app/components/ChallengeSelector/components/ChallengeLevelSelector"
import ChallengeDifficultyDetails from "app/components/ChallengeSelector/components/ChallengeDifficultyDetails"
import ChallengeSubscriptionProgressBar from "app/components/ChallengeSubscriptionProgressBar"
import SubscriptionSuccessAnimation from "./SubscriptionSuccessAnimation"

import { colors } from "app/lib/styles"

import { navigateTo } from "app/actions/app"

import {
  initiateNewChallengeSubscription,
  clearLatestSubscription,
  hideSubscriptionConcludedExperience,
  updateChallengeSubscription,
} from "app/actions/challenges"

import {
  downloadScrapedImage,
  uploadImage,
  uploadImageAndSavePost,
  savePost,
  setRunInBackground,
  updateAttribute,
  editAttribute,
  togglePostType,
  activatePost,
} from "app/actions/newPost"

const {
  StatusBar,
  View,
  SafeAreaView,
  Platform,
  StyleSheet,
  InteractionManager,
} = ReactNative

class SubscriptionConcludedExperience extends React.Component {
  state = {
    successAnimationCompleted: false,
    finishedSharing: false,
    editingSharePostDescription: false,
    sharePostDescription: null,
    successViewedAtLoad: false,
  }

  constructor(props) {
    super(props)
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.newPost.base.submitting && this.props.newPost.base.submitting) {
      this.doProceed()
    }
  }

  componentDidMount() {
    this.setState({
      successViewedAtLoad: this.sub ? this.sub.success_viewed : false,
    })

    if (this.sub && this.sub.succeeded && !this.sub.success_viewed) {
      if (this.user && !this.user.mute_challenge_sounds) {
        playSound("challenge_concluded_successfully")
      }
    }
  }

  get sub() {
    var id = this.props.challenges.concludedSubscriptionId
    if (!id) {
      id = this.props.challenges.latestChallengeSubscriptionId
    }
    if (id) {
      return dataStore.get("challenge_subscription", id)
    }
    return null
  }

  get user() {
    return dataStore.get("user", this.props.currentUserId)
  }

  get beatLastLevel() {
    return this.sub && this.sub.beatLastLevel
  }

  get subscribeRequiresUserIntervention() {
    return (
      this.sub &&
      this.sub.recommended_next_challenge_id &&
      this.sub.recommended_next_challenge_difficulty_id &&
      (this.beatLastLevel || !this.sub.succeeded)
    )
  }

  get badgeImageUrl() {
    return this.sub.share_badge_image_url
  }

  //Subscribe user to recommended challenge
  doNextSubscribe = () => {
    //If user is on a team and finishes last level, they'll get recommended the same level again
    //In that case, just don't subscribe them
    if (
      this.sub.recommended_next_challenge_id &&
      !(
        this.user.challenge_code_id &&
        this.sub.challenge_id === this.sub.recommended_next_challenge_id &&
        this.sub.challenge_difficulty_id ===
          this.sub.recommended_next_challenge_difficulty_id &&
        this.sub.succeeded
      )
    ) {
      InteractionManager.runAfterInteractions(() => {
        this.props.dispatch(
          initiateNewChallengeSubscription(
            this.sub.recommended_next_challenge_id,
            this.sub.recommended_next_challenge_difficulty_id
          )
        )
      })
    }
  }

  handleLevelInfoClose = () => {
    this.setState({
      challengeLevelInfoShowing: false,
    })
    if (!this.sub.active) {
      this.props.dispatch(
        updateChallengeSubscription(this.sub.id, "success_viewed", true)
      )
    }
  }

  handleLevelInfoPress = (nextChallenge, nextDifficulty) => {
    this.setState({
      challengeLevelInfoShowing: true,
    })
  }

  //User failed, or got to last level.  Subscribe them to recommended challenge and close
  handleAcceptPress = () => {
    this.doNextSubscribe()
    this.props.dispatch(hideSubscriptionConcludedExperience())
  }

  doProceed = () => {
    if (
      this.subscribeRequiresUserIntervention &&
      this.sub.succeeded &&
      !this.state.finishedSharing
    ) {
      this.setState({
        finishedSharing: true,
      })
    } else {
      this.props.dispatch(hideSubscriptionConcludedExperience())
      setTimeout(() => {
        if (!this.sub.active) {
          this.props.dispatch(
            updateChallengeSubscription(this.sub.id, "success_viewed", true)
          )
        }
      }, 1000)
    }
  }

  addDetails = () => {
    this.setState({
      editingSharePostDescription: !this.state.editingSharePostDescription,
    })
  }

  //First we download the badge image, then we share it!
  doShare = (title, totalDays) => {
    var shareText = `Hey! I just completed ${totalDays} day${
      totalDays === 1 ? "" : "s"
    } on ${
      this.sub.challenge.name_in_a_sentence
    } on the Foodstand App. I'm super proud of my progress so far, so I wanted to share with you =). If you want to join me, you can get the app --> thefoodstand.com/download and add me as a buddy I'm ${
      this.user.username
    }. We can help each other stay on track.`

    if (
      !this.props.newPost.base.processingRemoteImage &&
      !this.props.newPost.base.submitting
    ) {
      this.props.dispatch(setRunInBackground(true))
      this.props.dispatch(updateAttribute("title", title))
      this.props.dispatch(updateAttribute("description", this.state.sharePostDescription))
      this.props.dispatch(
        updateAttribute("challenge_group_ids", [this.sub.challenge.challenge_group_id])
      )
      this.props.dispatch(togglePostType(PostType.getIdForName("Just for Fun")))

      //Set the remote image url
      this.props.dispatch(updateAttribute("image_url", this.badgeImageUrl))

      //Submit the post
      setTimeout(() => {
        this.props.dispatch(savePost(this.props.newPost.base.post))
      }, 10)
    }
  }

  handleChangePress = () => {
    this.props.dispatch(
      navigateTo("challenge_selector", {
        title: "Change Challenge",
        onSubscribe: this.doProceed,
      })
    )
  }

  renderLevelInfo(nextChallenge = null, nextDifficulty = null) {
    var visible = this.state.challengeLevelInfoShowing && nextChallenge && nextDifficulty

    return (
      <FS.Modal
        animation="slideInUp"
        closeAnimation="slideOutDown"
        duration={250}
        visible={visible}
      >
        {visible ? (
          <ChallengeLevelSelector
            navigation={this.props.navigation}
            challenge={nextChallenge}
            difficultyLevel={nextDifficulty.difficulty_level}
            activeLevelOnly={true}
            informationOnly={true}
            onBack={this.handleLevelInfoClose}
          />
        ) : null}
      </FS.Modal>
    )
  }

  renderChallengeDetails(challenge, diff) {
    if (challenge.id === this.sub.challenge_id) {
      return (
        <View style={styles.nextDescWrap}>
          <ChallengeDifficultyDetails
            challengeDifficultyId={diff.id}
            style={styles.levelDetailAttributes}
          />
        </View>
      )
    } else {
      return (
        <View style={styles.nextDescWrap}>
          <FS.Text style={styles.nextDesc}>{challenge.description}</FS.Text>
        </View>
      )
    }
  }

  renderAcceptOrChangeDialog(nextChallenge, nextDifficulty) {
    if (
      !this.subscribeRequiresUserIntervention ||
      (this.sub.succeeded &&
        !this.state.finishedSharing &&
        !this.state.successViewedAtLoad)
    ) {
      return
    }

    return (
      <Animatable.View style={styles.dialog} animation={"fadeIn"}>
        {nextChallenge ? (
          <FS.Touchable
            style={styles.touchableChallenge}
            onPress={() => this.handleLevelInfoPress(nextChallenge, nextDifficulty)}
          >
            <ChallengeIcon
              challenge={nextChallenge}
              width={40}
              height={40}
              style={styles.nextIcon}
            />
            <FS.Text style={styles.nextLevelName}>
              {nextDifficulty.displayName.replace("Level ", "")}
            </FS.Text>
          </FS.Touchable>
        ) : null}

        <FS.ScrollView style={styles.nextChallengeArea}>
          {nextChallenge ? (
            <FS.Text style={styles.nextName}>{nextChallenge.name}</FS.Text>
          ) : null}

          <View style={styles.concludedMessageArea}>
            {this.sub.next_challenge_info_title ? (
              <FS.Text style={styles.nextChallengeInfoTitle}>
                {this.sub.next_challenge_info_title}
              </FS.Text>
            ) : null}

            {this.sub.next_challenge_info_desc ? (
              <FS.Text style={styles.nextChallengeInfoDesc}>
                {this.sub.next_challenge_info_desc}
              </FS.Text>
            ) : null}
          </View>

          {this.user && this.user.challenge_code_id === null
            ? this.renderChallengeDetails(nextChallenge, nextDifficulty)
            : null}

          {nextChallenge ? (
            <View style={styles.nextChallengeAreaContent}>
              <FS.Touchable style={styles.acceptButton} onPress={this.handleAcceptPress}>
                <FS.Text style={styles.acceptButtonText}>Let's do this</FS.Text>
              </FS.Touchable>
              {!this.sub.succeeded && !(this.user && this.user.challenge_code_id) ? (
                <FS.Touchable
                  style={styles.changeButton}
                  onPress={this.handleChangePress}
                >
                  <FS.Text style={styles.changeButtonText}>Change Challenge</FS.Text>
                </FS.Touchable>
              ) : (
                <View style={styles.changeButton} />
              )}
            </View>
          ) : null}
        </FS.ScrollView>
      </Animatable.View>
    )
  }

  renderShareDialog(nextChallenge, nextDifficulty) {
    if (!this.sub.succeeded || this.state.finishedSharing || this.sub.success_viewed) {
      return
    }

    var totalDays = 0
    this.sub.challenge.challenge_difficulties.forEach(diff => {
      if (diff.difficulty_level <= this.sub.challenge_difficulty.difficulty_level) {
        totalDays += diff.duration_days
      }
    })

    var shareText = `I just made it to Level ${RomanNumerals.toRoman(
      nextDifficulty.difficulty_level
    )} on the ${nextChallenge.name_in_a_sentence}!`
    if (this.sub.day_progress.length > 1) {
      shareText = `I made it ${totalDays} day${totalDays === 1 ? "" : "s"} on the ${
        nextChallenge.name_in_a_sentence
      }!`
    }

    var heading = ""
    if (this.beatLastLevel) {
      heading = "You've conquered the last level of this challenge!!"
      shareText = `I conquered the ${
        this.sub.challenge.name_in_a_sentence
      } - ${totalDays} day${totalDays === 1 ? "" : "s"}!`
      nextChallenge = this.sub
      nextDifficulty = this.sub.challenge_difficulty
    } else {
      heading = `You unlocked Level ${RomanNumerals.toRoman(
        nextDifficulty.difficulty_level
      )}!`
      heading += `  Keep it up for ${nextDifficulty.duration_days} more day${
        nextDifficulty.duration_days === 1 ? "" : "s"
      }`
      if (nextDifficulty.allowed_slips) {
        heading += ` w/ ${nextDifficulty.allowed_slips} free pass${
          nextDifficulty.allowed_slips === 1 ? "" : "es"
        }`
      }
      heading += "."
    }

    return (
      <Animatable.View style={styles.dialog} animation={"fadeIn"}>
        <FS.Touchable
          onPress={this.state.finishedSharing ? null : () => this.doProceed()}
          style={styles.shareDialogCancelButton}
        >
          <FS.Icon name="x-circle" style={styles.shareDialogCancelButtonIcon} />
        </FS.Touchable>

        {nextChallenge ? (
          <View style={styles.touchableChallenge}>
            <ChallengeIcon
              challenge={nextChallenge}
              width={40}
              height={40}
              style={styles.nextIcon}
            />
            <FS.Text style={styles.nextLevelName}>
              {nextDifficulty.displayName.replace("Level ", "")}
            </FS.Text>
          </View>
        ) : null}

        <FS.ScrollView style={styles.shareContentWrap}>
          <FS.Text style={styles.shareHeading}>{heading}</FS.Text>

          <View style={styles.postPreviewWrap}>
            <FS.Image
              source={{ uri: this.badgeImageUrl }}
              style={styles.postPreviewImage}
              imgixAttrs={{ dpr: 1 }}
            />
            <View style={styles.postPreviewInfo}>
              <FS.Text style={styles.postPreviewText}>{shareText}</FS.Text>
            </View>
          </View>

          <FS.Touchable
            style={styles.shareButton}
            onPress={() => this.doShare(shareText, totalDays)}
          >
            <FS.Text style={styles.shareButtonText}>
              {this.props.newPost.base.processingRemoteImage ||
              this.props.newPost.base.submitting
                ? "Submitting Post..."
                : "Share"}
            </FS.Text>
          </FS.Touchable>

          <FS.Touchable style={styles.moreDetailsButton} onPress={this.addDetails}>
            <FS.Text style={styles.moreDetailsButtonText} numberOfLines={1}>
              {this.state.sharePostDescription ? "Edit: " : "Optional: "}
              <FS.Text style={styles.moreDetailsButtonActionText} numberOfLines={1}>
                {this.state.sharePostDescription
                  ? this.state.sharePostDescription
                  : "+Add Details to Foodstand Post"}
              </FS.Text>
            </FS.Text>
          </FS.Touchable>
        </FS.ScrollView>
      </Animatable.View>
    )
  }

  renderShareDescriptionEditor() {
    if (this.state.editingSharePostDescription) {
      return (
        <SafeAreaView style={[styles.container, styles.valueEditorWrap]}>
          <ValueEditor
            type="text"
            title="Description"
            placeholder="Tell the community about your experience so far!  Include how you feel and tips to help others."
            animated={true}
            onCancel={this.addDetails}
            onDone={result => {
              this.setState({
                sharePostDescription: result,
                editingSharePostDescription: false,
              })
            }}
            value={this.state.sharePostDescription}
            rightButtonText={"Done"}
            onBack={this.addDetails}
            hideStatusBar={true}
            maxLength={2000}
          />
        </SafeAreaView>
      )
    }
  }

  renderSuccessAnimation() {
    if (!this.state.successAnimationCompleted && !this.sub.success_viewed) {
      return (
        <SubscriptionSuccessAnimation
          successText={this.sub.concluded_message}
          subscription={this.sub}
          onCompletion={() => {
            this.setState({ successAnimationCompleted: true })
          }}
        />
      )
    }
  }

  render() {
    if (!this.props.challenges.subscriptionConcluded || !this.sub) {
      return <View />
    }

    var nextChallenge = dataStore.get("challenge", this.sub.recommended_next_challenge_id)
    var nextDifficulty = dataStore.get(
      "challenge_difficulty",
      this.sub.recommended_next_challenge_difficulty_id
    )

    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.shadow}>
          <FS.Touchable
            onPress={this.state.finishedSharing ? null : this.doProceed}
            style={styles.shadowButton}
          />
        </View>
        {this.sub.succeeded ? this.renderSuccessAnimation() : null}
        {this.renderAcceptOrChangeDialog(nextChallenge, nextDifficulty)}
        {this.renderShareDialog(nextChallenge, nextDifficulty)}
        {this.renderLevelInfo(nextChallenge, nextDifficulty)}
        {this.renderShareDescriptionEditor()}
      </SafeAreaView>
    )
  }
}

function mapStateToProps(state) {
  return Object.assign(
    {},
    {
      challenges: state.challenges,
      checkins: state.checkins,
      newPost: state.newPost,
      currentUserId: state.app.currentUserId,
    }
  )
}

export default connect(mapStateToProps)(SubscriptionConcludedExperience)

var styles = StyleSheet.create({
  container: {
    flex: Platform.OS !== "web" ? 0 : null,
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    justifyContent: "center",
    alignItems: "center",
  },
  valueEditorWrap: {
    justifyContent: null,
    alignItems: null,
  },
  shadow: {
    flex: 1,
    position: "absolute",
    top: -20,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  shadowButton: {
    borderColor: colors.orange,
    flex: 1,
    position: "absolute",
    top: -20,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: "transparent",
  },
  dialog: {
    flex: Platform.OS !== "web" ? 0 : null,
    marginTop: Device.width > 320 ? 80 : 60,
    marginHorizontal: Device.width > 320 ? 20 : 10,
    marginBottom: Device.width > 320 ? 40 : 20,
    backgroundColor: colors.white,
    width: Device.width - (Device.width > 320 ? 20 : 10) * 2,
    borderRadius: 6,
    padding: 18,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
  },
  challengeSelectorWrap: {
    flex: 1,
    backgroundColor: colors.challengeDarkRed,
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  challengeSelectorWrapHidden: {
    right: -Device.width,
  },
  nextChallengeInfoTitle: {
    fontSize: 18,
    letterSpacing: -0.5,
    fontWeight: "600",
    textAlign: "center",
    margin: 5,
  },
  nextChallengeInfoDesc: {
    fontSize: 16,
    fontWeight: "300",
    textAlign: "center",
    margin: 10,
  },
  progressBar: {
    marginHorizontal: 20,
    marginRight: 0,
  },
  headingArea: {
    borderBottomWidth: 0.5,
    borderColor: colors.lightMediumGray,
    marginBottom: 20,
    paddingBottom: 20,
  },
  nextChallengeArea: {
    flex: Platform.OS !== "web" ? 0 : null,
    zIndex: 1,
    marginTop: -20,
  },
  nextChallengeAreaContent: {
    alignItems: "center",
    flex: Platform.OS !== "web" ? 0 : null,
  },
  touchableChallenge: {
    alignItems: "center",
    marginTop: Platform.OS === "ios" ? -70 : 0,
    borderRadius: 50,
    width: 100,
    height: 100,
    backgroundColor: colors.white,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  nextLevelName: {
    textAlign: "center",
    backgroundColor: colors.challengeOrange,
    color: colors.white,
    borderWidth: 2,
    borderColor: colors.white,
    borderRadius: 18,
    fontSize: 16,
    letterSpacing: -0.3,
    fontWeight: "500",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: Platform.OS === "ios" ? 36 : 28,
    position: Platform.OS === "ios" ? "absolute" : "relative",
    right: Platform.OS === "ios" ? -16 : 0,
    top: Platform.OS === "ios" ? 35 : 2,
    width: 36,
    height: 36,
    overflow: "hidden",
  },
  nextLevelInfoRow: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 25,
  },
  nextIcon: {},
  nextName: {
    textAlign: "center",
    color: colors.challengeOrange,
    fontSize: 16,
    letterSpacing: -0.3,
    fontWeight: "700",
    marginHorizontal: 20,
  },
  nextTitle: {
    textAlign: "center",
    color: colors.challengeOrange,
    fontSize: 18,
    letterSpacing: -0.3,
    fontWeight: "800",
    marginHorizontal: 10,
    marginTop: 10,
  },
  nextDescWrap: {
    flex: 1,
  },
  nextDesc: {
    marginTop: 5,
    textAlign: "center",
    color: colors.gray,
    fontSize: 14,
    letterSpacing: -0.3,
    marginHorizontal: 20,
  },
  acceptButton: {
    marginTop: 35,
    backgroundColor: colors.challengeOrange,
    padding: 12,
    paddingHorizontal: 20,
    borderRadius: 6,
  },
  acceptButtonText: {
    color: colors.white,
    fontSize: 16,
    fontWeight: "600",
    letterSpacing: -0.4,
  },
  changeButton: {
    marginTop: 18,
    marginBottom: 20,
  },
  changeButtonText: {
    color: colors.gray,
    fontSize: 14,
    fontWeight: "600",
    letterSpacing: -0.4,
  },
  levelDetailAttributes: {
    marginTop: 10,
    marginBottom: -20,
  },
  shareContentWrap: {
    marginTop: -10,
  },
  shareHeading: {
    color: colors.challengeOrange,
    textAlign: "center",
    fontSize: 18,
    fontWeight: "600",
  },
  moreDetailsButton: {
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingHorizontal: 5,
    flexDirection: "row",
  },
  moreDetailsButtonText: {
    textAlign: "center",
    fontWeight: "500",
    fontSize: 12,
    color: colors.mediumGray,
  },
  moreDetailsButtonActionText: {
    textAlign: "center",
    fontWeight: "700",
    fontSize: 12,
    color: colors.mediumGray,
    paddingLeft: 2,
  },
  postPreviewWrap: {
    flexDirection: "row",
    marginTop: 20,
    borderWidth: 1,
    borderColor: colors.lightMediumGray,
    borderRadius: 4,
    backgroundColor: colors.lightGray,
    alignItems: "center",
  },
  postPreviewImage: {
    margin: -1,
    marginRight: 0,
    borderRadius: 4,
    borderTopRightRadius: 4,
    borderBottomRightRadius: 0,
    width: 103,
    height: 103,
  },
  postPreviewInfo: {
    flex: 1,
    flexWrap: "wrap",
    padding: 10,
    paddingLeft: 15,
  },
  postPreviewText: {
    fontSize: 14,
    lineHeight: 19,
    fontWeight: "500",
    color: colors.darkGray,
  },
  shareButton: {
    marginTop: 18,
    backgroundColor: colors.challengeOrange,
    borderRadius: 6,
    height: 46,
    justifyContent: "center",
  },
  shareButtonText: {
    fontSize: 16,
    color: colors.white,
    fontWeight: "600",
    textAlign: "center",
  },
  shareDialogCancelButton: {
    position: "absolute",
    right: -11,
    top: -11,
    right: Platform.OS === "ios" ? -11 : 5,
    top: Platform.OS === "ios" ? -11 : 5,
    padding: 5,
    backgroundColor: "transparent",
  },
  shareDialogCancelButtonIcon: {
    fontSize: 25,
    color: colors.mediumGray,
  },
  shareSwitch: {
    transform: [{ scale: 0.8 }],
    marginRight: -10,
  },
})
